import React, {
    Component
} from 'react'
import {
    Link,
    NavLink
} from 'react-router-dom'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ImageS3SignedUrl from '~/widgets/image-s3-signed-url'
import awsconfig from '~/awsconfig';


class ModalReportPhotosLightbox extends Component {
    constructor() {
        super()

        this.state = {
            src: null,
            photos: [],
            index: 0,
            photo: {},
            imageHeight: '0px',
        }
    }

    imageSizeRefCallback(element) {
        if(!element){
            return
        }
        let imageHeight = `${element.clientHeight}px`;
        if(this.state.imageHeight !== imageHeight){
            this.setState({
                imageHeight: imageHeight,
            })
        }
    }

    render() {
        if(!this.props.report.photos){
            this.props.closeModal();
            return ''
        }

        console.log(this.state);
        console.log(this.props);

        let report = this.props.report;
        let photos = this.props.report.photos || [];
        let index = photos.findIndex(x=>x._id===this.props.match.params.photo_id);
        let photo = photos[index];

        console.log(index)
        console.log(photos.length)

        return (
            <div className="modal-lightbox modal">
                <div className="modal-header">
                    <div className="modal-title">
                        Report {this.props.report.accidentNumber ? `#${this.props.report.accidentNumber}` : '- No Accident Number'}
                        &nbsp;
                        &mdash; Photo {index + 1} of {photos.length}
                    </div>
                </div>
                <div className="modal-content" ref={this.imageSizeRefCallback.bind(this)}>
                    <div className="flex-horizontal">
                        <div className="flex-left">
                            {index === 0 ? null : (
                                <Link to={`/app/reports/${report._id}/${this.props.match.params.view}/modal/lightbox/${photos[index-1]._id}`}>
                                    <ChevronLeftIcon fontSize='inherit'/>
                                </Link>
                            )}
                        </div>
                        <div className="flex-center">
                            <ImageS3SignedUrl
                                width='auto'
                                height={this.state.imageHeight}
                                signedUrlRedirect={`${awsconfig.officeApi}/reports/${report._id}/${photo._id}`}
                            />
                        </div>
                        <div className="flex-right">
                            {index + 1 >= photos.length ? null : (
                                <Link to={`/app/reports/${report._id}/${this.props.match.params.view}/modal/lightbox/${photos[index+1]._id}`}>
                                    <ChevronRightIcon fontSize='inherit'/>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div onClick={this.props.closeModal.bind(this)} className={`button button-gray`}>
                        Close
                    </div>
                </div>
            </div>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            report: state.reports.detail || {},
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    }
)(ModalReportPhotosLightbox);